<div class="consult-table-section">
  <div class="consult-table-shell">
    <ng-container *ngIf="itens.length > 0; else emptyTableState">
      <b3-table
        size="sm"
        background="striped"
        aria-label="Lista de operações de confirmação"
        [attr.aria-rowcount]="totalItens"
        aria-colcount="8">
        <b3-table-rowgroup group="header">
          <b3-table-row>
            <b3-table-cell-header label="Data da Operação"></b3-table-cell-header>
            <b3-table-cell-header label="Cód. Carbono"></b3-table-cell-header>
            <b3-table-cell-header label="Cód. Conta Registrador"></b3-table-cell-header>
            <b3-table-cell-header label="Cód. Conta Detentor"></b3-table-cell-header>
            <b3-table-cell-header label="Qtd" align="end"></b3-table-cell-header>
            <b3-table-cell-header label="Tipo Operação"></b3-table-cell-header>
            <b3-table-cell-header label="Nº Controle"></b3-table-cell-header>
            <b3-table-cell-header label="Ações" align="center"></b3-table-cell-header>
          </b3-table-row>
        </b3-table-rowgroup>

        <b3-table-rowgroup group="body">
          <b3-table-row
            *ngFor="let operation of itens; trackBy: trackByOperationCode"
            [id]="'operation-confirmation-row-' + operation.operationCode">
            <b3-table-cell variant="text" [label]="operation.insertDate || '-'"></b3-table-cell>
            <b3-table-cell variant="slot">
              @let carbonCode = getCarbonCreditCode(operation);
              <b3-tooltip
                *ngIf="carbonCode; else emptyCarbonCode"
                [label]="carbonCode"
                variant="single-line"
                pointer="bottom">
                <span class="consult-table-carbon-code" tabindex="0">{{ carbonCode }}</span>
              </b3-tooltip>
              <ng-template #emptyCarbonCode>
                <span class="consult-table-carbon-code consult-table-carbon-code--empty">-</span>
              </ng-template>
            </b3-table-cell>
            <b3-table-cell variant="text" [label]="operation.registerCode || '-'"></b3-table-cell>
            <b3-table-cell variant="text" [label]="operation.holderCode || '-'"></b3-table-cell>
            <b3-table-cell variant="number" [label]="formatQuantity(operation.creditQuantity)"></b3-table-cell>
            <b3-table-cell variant="tag">
              @let operationTypeBadge = getOperationTypeBadge(operation);
              <b3-tag
                size="sm"
                variant="filled"
                [icon]="operationTypeBadge.icon"
                [tone]="operationTypeBadge.tone"
                [label]="operationTypeBadge.label">
              </b3-tag>
            </b3-table-cell>
            <b3-table-cell variant="slot">
              @let controlLines = getOperationControlNumberLines(operation);
              <b3-tooltip
                *ngIf="controlLines; else emptyControlNumber"
                [label]="getOperationControlNumber(operation)"
                variant="single-line"
                pointer="bottom">
                <button
                  type="button"
                  class="consult-table-control-number"
                  [attr.aria-label]="getOperationControlNumberAriaLabel(operation)"
                  (click)="copyOperationControlNumber(operation, $event)">
                  <span class="consult-table-control-number__line">{{ controlLines.primary }}</span>
                  <span
                    *ngIf="controlLines.secondary"
                    class="consult-table-control-number__line">
                    {{ controlLines.secondary }}
                  </span>
                </button>
              </b3-tooltip>
              <ng-template #emptyControlNumber>
                <span class="consult-table-control-number consult-table-control-number--empty">-</span>
              </ng-template>
            </b3-table-cell>
            <b3-table-cell variant="slot">
              <div class="consult-table-actions">
                @if (isPendingApproval(operation)) {
                  <b3-tooltip label="Aprovar" variant="single-line" pointer="bottom">
                    <b3-button
                      type="button"
                      variant="ghost"
                      tone="default"
                      size="sm"
                      [attr.aria-label]="getApproveLabel(operation)"
                      (b3-click)="emitAction(ClickEnumConfirmation.APROVAR, operation)">
                      <b3-icon name="select_check_box"></b3-icon>
                    </b3-button>
                  </b3-tooltip>
                  <b3-tooltip label="Rejeitar" variant="single-line" pointer="bottom">
                    <b3-button
                      type="button"
                      variant="ghost"
                      tone="default"
                      size="sm"
                      [attr.aria-label]="getRejectLabel(operation)"
                      (b3-click)="emitAction(ClickEnumConfirmation.REJEITAR, operation)">
                      <b3-icon name="cancel"></b3-icon>
                    </b3-button>
                  </b3-tooltip>
                }
                <b3-tooltip label="Detalhes" variant="single-line" pointer="bottom">
                  <b3-button
                    type="button"
                    variant="ghost"
                    tone="default"
                    size="sm"
                    [attr.aria-label]="getDetailsLabel(operation)"
                    (b3-click)="emitAction(ClickEnumConfirmation.DETALHES, operation)">
                    <b3-icon name="visibility"></b3-icon>
                  </b3-button>
                </b3-tooltip>
              </div>
            </b3-table-cell>
          </b3-table-row>
        </b3-table-rowgroup>
      </b3-table>
    </ng-container>

    <ng-template #emptyTableState>
      <app-consult-table-empty-state></app-consult-table-empty-state>
    </ng-template>
  </div>

  <div class="consult-table-pagination" *ngIf="itens.length > 0">
    <p class="consult-table-pagination__info">{{ recordsPerPageLabel }}</p>
    <b3-pagination
      aria-label="Paginação de operações de confirmação"
      variant="numbers"
      navigation="icon"
      overflow
      [attr.total]="totalPages"
      [attr.current]="pagination.page ?? 1"
      (b3-change)="onPaginationChange($event)">
    </b3-pagination>
  </div>
</div>
